angular.module('impactx.product').controller('AdditionalMainProductDataCtrl', [
    '$scope',
    '$mdDialog',
    'themeFactory',
    'dataGen',
    'data',
    'headerLabel',
    'confirmLabel',
    'abortLabel',
    'noSelectedItemMessage',
    'freeSelectionMessage',
    'energieLabelHeaderLabel',
    'energieLabelMMD',
    'energieLabelDescriptionMMD',
    AdditionalMainProductDataCtrl]);

function AdditionalMainProductDataCtrl($scope, $mdDialog, themeFactory, dataGen, data, headerLabel, confirmLabel, abortLabel, noSelectedItemMessage, freeSelectionMessage, energieLabelHeaderLabel, energieLabelMMD, energieLabelDescriptionMMD)
{
    $scope.theme = themeFactory.getTheme();
    $scope.readOnly = data.readOnly;
    //copy main data so we can revert it.
    $scope.additionalMainData = JSON.parse(JSON.stringify(data.additionalMainData));
    $scope.confirmLabel = confirmLabel;
    $scope.abortLabel = abortLabel;
    $scope.headerLabel = headerLabel;
    $scope.noSelectedItemMessage = noSelectedItemMessage;
    $scope.freeSelectionMessage = freeSelectionMessage;
    $scope.energieLabelHeaderLabel = energieLabelHeaderLabel;
    $scope.energieLabelMMD = energieLabelMMD;
    $scope.energieLabelDescriptionMMD = energieLabelDescriptionMMD;

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };

    this.confirm = function ()
    {
        data.additionalMainData = $scope.additionalMainData;
        $mdDialog.hide();
    };

    this.addKeyWord = function()
    {
        $scope.additionalMainData.keyWordList.push({value: ""});
    };

    this.removeKeyWord = function(index)
    {
        $scope.additionalMainData.keyWordList.splice(index, 1);
    };

    this.clearEuEnergieLabelValue = function ()
    {
        if ($scope.additionalMainData.euEnergieLabelValue.selected) {
            $scope.additionalMainData.euEnergieLabelValue.selected = undefined;
        }
    };

}